// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.22-13294(5ec6dab39c)-C03/11/2026-14:17:47-B03/11/2026-14:48:06' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.22-13294(5ec6dab39c)-C03/11/2026-14:17:47-B03/11/2026-14:48:06",
  branch: "production",
  latestTag: "8.0.22",
  revCount: "13294",
  shortHash: "5ec6dab39c",
  longHash: "5ec6dab39cfbaddbb4c3a90caca5e364fc137e89",
  dateCommit: "03/11/2026-14:17:47",
  dateBuild: "03/11/2026-14:48:06",
  buildType: "Ansible",
  } ;
